import {IToJson} from '@toolify/client/src/types/IToJson'

import {mapUserResponseInstance} from '@toolify/client/src/modules/api/singletons/mapUserResponseInstance'
import {
  IWorkspaceInvitationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspaceInvitationResponseInstance'

export function mapWorkspaceInvitationResponseInstance(
  workspaceInvitation: IToJson<IWorkspaceInvitationResponseInstance>,
): IWorkspaceInvitationResponseInstance {
  return {
    ...workspaceInvitation,
    author: mapUserResponseInstance(workspaceInvitation.author),
  }
}
